const DelimiterRenderer = () => {
    return (
        <hr className="divider divider-md-0 bg-madison"/>
    )
}
export default DelimiterRenderer;